import type React from "react";
import { colors } from "src/theme";

// Hides content visually but keeps it available to screen readers and keyboard focus
export const visuallyHidden = {
  position: 'absolute' as const,
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap' as const,
  border: 0,
};

export const focusRing = {
  outline: `2px solid ${colors.primary}`,
  outlineOffset: '2px',
};

// Id of the validation message rendered under a field, used for aria-describedby
export const errorIdFor = (id?: string) => (id ? `${id}-error` : undefined);

// Props that link an input to its validation message
export const errorA11yProps = (id: string | undefined, error?: string) => ({
  'aria-invalid': error ? true : undefined,
  'aria-describedby': error ? errorIdFor(id) : undefined,
});

// Moves focus to the first invalid field inside a container, after React has rendered the errors
export const focusFirstInvalid = (container?: HTMLElement | null) => {
  setTimeout(() => {
    const root = container || document;
    const invalid = root.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (invalid) {
      invalid.focus();
      invalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, 0);
};

// Checkboxes and radios natively react only to Space; users also expect Enter to select them
export const onEnterKey = (action: () => void) => (e: React.KeyboardEvent<HTMLElement>) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    action();
  }
};
